import { EMPTY_LIST } from '../../../constants/common'

export const EMAIL_COPY_TO_ENTITY_MODAL_API_FIELD = {
  entityId: 'entity_id',
  entityName: 'entity_name',
}

export const EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER = 'user'

export const EMAIL_COPY_TO_ENTITY_MODAL_INITIAL_VALUES = {
  [EMAIL_COPY_TO_ENTITY_MODAL_FIELD_NAME_USER]: EMPTY_LIST,
}

export const EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_USER = 'userprofile'

export const EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_FLAT = 'flat'

export const EMAIL_COPY_TO_ENTITY_MODAL_API_ENTITY_NAME_BUILDING = 'building'

export const EMAIL_COPY_TO_ENTITY_MODAL_IS_PRIVATE_CONFIRMATION_AGAIN_DISABLED =
  'copy_to_entity_is_private_confirmation_again_disabled'
